"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColunaAgrupadaFormulario = void 0;
var react_1 = __importDefault(require("react"));
var FormularioGrid_1 = require("../FormularioGrid/FormularioGrid");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var HelperText_1 = require("../../HelperText/HelperText");
var Cores_1 = require("../../Cores/Cores");
var ColunaAgrupadaFormulario = function (_a) {
    var id = _a.id, _b = _a.width, width = _b === void 0 ? 100 : _b, _c = _a.height, height = _c === void 0 ? "100%" : _c, minHeight = _a.minHeight, children = _a.children, _d = _a.className, className = _d === void 0 ? "" : _d, style = _a.style, conteudoDeAjuda = _a.conteudoDeAjuda;
    if (globalMu_1.default.isNullOrEmptyOrUndefined(style) && conteudoDeAjuda) {
        style = { border: '1px', padding: 4, borderStyle: 'solid', borderColor: Cores_1.Cores.MensagensDoSistema.VermelhoMU, borderRadius: 12 };
    }
    var ConteudoAjuda = (react_1.default.createElement("div", { style: { marginTop: 8 } },
        react_1.default.createElement(HelperText_1.HelperText, { texto: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.texto) || '', estado: conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.estado, icone: conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.icone })));
    return (react_1.default.createElement(FormularioGrid_1.FormularioGrid, { id: id, style: { padding: 4 }, className: className, tipo: "column", width: width, height: height, minHeight: minHeight },
        react_1.default.createElement("div", { style: style }, children),
        conteudoDeAjuda && ConteudoAjuda));
};
exports.ColunaAgrupadaFormulario = ColunaAgrupadaFormulario;
